export default "__VITE_ASSET__CYBGPJ7e__"